export default "__VITE_ASSET__AFseusWL__"